import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { BankDetails } from './BankDetails.entity';

export class CostCenter<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: deaktiviert */
  disabled?: boolean;
  /** Alias: ersteNummer */
  firstNumber?: number;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: letzteNummer */
  lastNumber?: number;
  /** Alias: mandantennummer */
  tenantNumber?: number;
  /** Alias: name */
  name?: string;
  /** Alias: nummer */
  number?: number;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: zusatz */
  additive?: string;
  /** Alias: bankverbindungCode */
  bankDetailsId?: number;
  /** Alias: bankverbindung */
  bankDetails?: BankDetails<T>;

  __typename?: string;
}

const fields: FieldDefinitions<CostCenter> = {
  id: {
    alias: 'code',
  },
  disabled: {
    alias: 'deaktiviert',
  },
  firstNumber: {
    alias: 'ersteNummer',
  },
  insertTime: {
    alias: 'insertTime',
  },
  lastNumber: {
    alias: 'letzteNummer',
  },
  tenantNumber: {
    alias: 'mandantennummer',
  },
  name: {
    alias: 'name',
  },
  number: {
    alias: 'nummer',
  },
  updateTime: {
    alias: 'updateTime',
  },
  additive: {
    alias: 'zusatz',
  },
  bankDetailsId: {
    alias: 'bankverbindungCode',
  },
  bankDetails: {
    alias: 'bankverbindung',
    entity: Entities.bankDetails,
  },
  __typename: {
    alias: '__typename',
  },
};

export const costCenterEntityDefinition: EntitiyDefinition<CostCenter> = {
  local: {},
  remote: {
    queryName: 'getCostCenter',
    fragmentName: 'Kostenstelle',
    withPaginationWrapper: true,
    mutations: {
      upsert: {
        mutationName: 'upsertCostCenter',
        args: [
          { name: 'input', type: 'InputKostenstelle!' },
          { name: 'drySave', type: 'Boolean' },
        ],
      },
    },
    params: [
      { name: 'querySize', type: 'Int' },
      { name: 'queryPage', type: 'Int' },
      { name: 'querySortOrder', type: 'SortOrderStyle' },
      { name: 'querySortBy', type: 'String' },
      { name: 'querySortByEx', type: '[SortByPair]' },
      { name: 'filter', type: 'String' },
    ],
  },
  fieldDefinitions: fields,
};
